import { render, staticRenderFns } from "./ContentMetrics.vue?vue&type=template&id=868fff02&scoped=true"
var script = {}
import style0 from "./ContentMetrics.vue?vue&type=style&index=0&id=868fff02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868fff02",
  null
  
)

export default component.exports